import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import NumberInCircle from "../../common/numberInCircle/numberInCircle";
import CustomButton from "../../common/customButton/customButton";
import "./testTakingScreen.css";
import CustomRadioButton from "../../common/customRadioButton/customRadioButton";
import { useSharedState } from "../../context/formsContext";
import { useNavigate, useLocation, usePrompt } from "react-router-dom";
import TimeSlider from "../../common/timeSlider/timeSlider";
import logoPointer from "../../assets/DownArrow.png";
import UniformLoader from "../../common/uniformLoader/uniformLoader";
import logo from "../../assets/ksolactipanel.png";
import gcseLogo from "../../assets/KSOL GCSE_logo.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getProperty } from "../../utils/apiResponseHelper";

const TestTakingScreen = () => {
  const [selectedAnswer, setSelectedAnswer] = useState([]);
  const {
    testQuestions,
    testAnswers,
    testData,
    setTestData,
    setTestAnswers,
    setCurriculumId,
    setQuestionId,
    questionId,
    index,
    setIndex,
    curriculumId,
    setSingleQuizQuestion,
    setTestQuestions,
    singleQuizQuestion,
    totalQuestions,
    setTotalQuestions,
    loading,
    setLoading,
    liveCurrentQuizQuestions,
    setLiveCurrentQuizQuestions,

    prefix,
  } = useSharedState();

  const [questionNumber, setQuestionNumber] = useState(1);
  const [showFinishButton, setShowFinishButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [remainingPercent, setRemainingPercent] = useState(0);
  const [finalTime, setFinalTime] = useState("");
  const [newPercent, setNewPercent] = useState(0);
  const [translatePercent, setTranslatePercent] = useState(0);
  const [error, setError] = useState("");
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [title, setTitle] = useState("");
  const [stateSliderWidth, setStateSliderWidth] = useState(0);
  const [quizSummaryId, setQuizSummaryId] = useState(0);
  const [circles, setCircles] = useState([]);
  const [buttonClick, setButtonClick] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
  const [questionUpdated, setQuestionUpdated] = useState(false);
  const [isBlocking, setIsBlocking] = useState(true);
  const [isGcse, setIsGcse] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const timeRemainingRef = useRef(timeRemaining);

  useEffect(() => {
    if (isGcse) {
      document.body.classList.add("gcse-mode");
    } else {
      document.body.classList.remove("gcse-mode");
    }
  }, [isGcse]);

  useEffect(() => {
    if (timeRemaining) {
      timeRemainingRef.current = timeRemaining;
    }
  }, [timeRemaining, testData]);

  useEffect(() => {
    if (testData && testData[index]) {
      const testItem = testData[index];
      const timeAllocated = getProperty(testItem, 'timeAllocatedSeconds') || getProperty(testItem, 'TimeAllocatedSeconds') || testItem?.TimeAllocatedSeconds || testItem?.timeAllocatedSeconds || 0;
      const timeUsed = getProperty(testItem, 'timeUsed') || getProperty(testItem, 'TimeUsed') || testItem?.TimeUsed || testItem?.timeUsed || 0;
      const remainingTime = Number(timeAllocated) - Number(timeUsed);
      setTimeRemaining(remainingTime);
    }
  }, []);

  const toastId = useRef(null);

  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, null, window.location.href);

      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.info("Please complete the test.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    };

    window.history.pushState(null, null, window.location.href);

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    if (!sessionLoginToken && testData) {
      navigate("/loginScreen");
    }
  }, []);

  useEffect(() => {
    if (!singleQuizQuestion || !singleQuizQuestion[0]) return;
    const questionItem = singleQuizQuestion[0];
    const questionNumber = (getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 1) - 1;
    const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 1;
    const sliderWidth = 100 / totalQuestions;

    const calculatedTranslatePercent = questionNumber * sliderWidth;

    setTranslatePercent(calculatedTranslatePercent);
    setStateSliderWidth(sliderWidth);
  }, [singleQuizQuestion]);

  const findCurrentQuestion = (fetchedTestQuestions) => {
    if (Array.isArray(fetchedTestQuestions)) {
      const currentQuestion = fetchedTestQuestions.find(
        (question) => {
          const isCurrent = getProperty(question, 'isCurrentQuestion') || getProperty(question, 'IsCurrentQuestion') || question?.IsCurrentQuestion || question?.isCurrentQuestion;
          return isCurrent === "Y";
        }
      );

      if (currentQuestion) {
        const questionToStart = getProperty(currentQuestion, 'curriculumId') || getProperty(currentQuestion, 'CurriculumId') || currentQuestion?.CurriculumId || currentQuestion?.curriculumId;
        setCurrentQuestion(currentQuestion);

        return { fetchedQuestionToStart: questionToStart };
      }
    }

    return null;
  };

  const widthCalculation = () => {
    if (!singleQuizQuestion || !singleQuizQuestion[0]) return;
    const questionItem = singleQuizQuestion[0];
    const amountOfQuestionsAttempted = getProperty(questionItem, 'totalAttempted') || getProperty(questionItem, 'TotalAttempted') || questionItem?.TotalAttempted || questionItem?.totalAttempted || 0;
    const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 1;
    const newPercent = (amountOfQuestionsAttempted / totalQuestions) * 100;
    setNewPercent(newPercent);
  };

  useEffect(() => {
    widthCalculation();
  }, [singleQuizQuestion]);

  const normalizeGraphicLocation = (graphicLocation) => {
    if (!graphicLocation || typeof graphicLocation !== "string") return "";
    const trimmed = graphicLocation.trim();
    if (!trimmed) return "";

    let pathValue = trimmed;

    // If a full URL is returned, extract just the pathname.
    if (/^https?:\/\//i.test(trimmed)) {
      try {
        pathValue = new URL(trimmed).pathname || "";
      } catch {
        pathValue = trimmed;
      }
    }

    // Enforce a consistent /graphics/<file> path regardless of source path.
    const fileName = pathValue.split("/").filter(Boolean).pop() || "";
    if (!fileName) return "";
    return `/graphics/${fileName}`;
  };

  const normalizeTestQuestions = (questions) => {
    if (!Array.isArray(questions)) return [];

    return questions.map((question) => {
      const rawGraphicLocation =
        getProperty(question, "graphicLocation") ||
        getProperty(question, "GraphicLocation") ||
        question?.GraphicLocation ||
        question?.graphicLocation ||
        "";
      const normalizedGraphicLocation = normalizeGraphicLocation(rawGraphicLocation);

      return {
        ...question,
        graphicLocation: normalizedGraphicLocation,
        GraphicLocation: normalizedGraphicLocation,
      };
    });
  };

  useEffect(() => {
    if (timeRemainingRef.current >= 0) {
      const minutes = Math.floor(timeRemainingRef.current / 60);
      const seconds = timeRemainingRef.current % 60;
      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
      setFinalTime(`${minutes}:${formattedSeconds}`);
    }
  }, [timeRemaining]);

  const submitTest = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      const response = await fetch(`${prefix}/api-40/api40/Lesson/SubmitTest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionLoginToken}`,
          "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
        },
        body: JSON.stringify({
          AnswerOptionId: 0,
          QuestionId: 0,
          AnswerPresentation: "",
          AnswerOptionType: 0,
          StudentAnswer: "",
          IsChecked: true,
          NewAnswer: "",
          CurrId: curriculumId,
          TimeUsed: 0,
        }),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to post time used: ${response.status} ${response.statusText}`
        );
      }

      localStorage.removeItem("singleQuizQuestion");
      localStorage.removeItem("selectedAnswer");
      localStorage.removeItem("timeRemaining");
      localStorage.removeItem("curriculumId");
      localStorage.removeItem("initalLoadComplete");
      localStorage.removeItem("refreshTriggered");
      localStorage.removeItem("totalQuestions");
      localStorage.removeItem("totalTime");
      localStorage.removeItem("previousTimeUsed");
      localStorage.removeItem("testQuestions");
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error submitting test data: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const handleFinishClick = () => {
    setIsBlocking(false);
    submitTest();
    navigate("/quizScreen");
  };

  const postTime = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    const currentQuizSummaryId = localStorage.getItem("quizSummaryId");

    if (!currentQuizSummaryId || currentQuizSummaryId === "undefined") {
      return;
    }

    let parsedQuizSummaryId;
    try {
      parsedQuizSummaryId = JSON.parse(currentQuizSummaryId);
    } catch (error) {
      // If parsing fails, try using it as a number directly
      parsedQuizSummaryId = currentQuizSummaryId;
    }

    if (!sessionLoginToken) {
      return;
    }

    try {
      const timeUsedInCurrentSession = timeRemainingRef.current;

      const sessionTotalTime = localStorage.getItem("totalTime");
      let totalTime = sessionTotalTime ? Number(sessionTotalTime) : null;
      if (!totalTime && testData && testData[index]) {
        const testItem = testData[index];
        totalTime = getProperty(testItem, 'timeAllocatedSeconds') || getProperty(testItem, 'TimeAllocatedSeconds') || testItem?.TimeAllocatedSeconds || testItem?.timeAllocatedSeconds || 0;
      }

      const sessionPreviousTime = localStorage.getItem("previousTimeUsed");
      let previousTimeUsed = sessionPreviousTime ? Number(sessionPreviousTime) : null;
      if (previousTimeUsed === null && testData && testData[index]) {
        const testItem = testData[index];
        const timeUsed = getProperty(testItem, 'timeUsed') || getProperty(testItem, 'TimeUsed') || testItem?.TimeUsed || testItem?.timeUsed || 0;
        previousTimeUsed = Number(timeUsed);
      }

      localStorage.setItem("totalTime", JSON.stringify(totalTime));

      localStorage.setItem(
        "previousTimeUsed",
        JSON.stringify(previousTimeUsed)
      );

      const startTime = totalTime - timeRemaining;

      const timeUsedInCurrentSessionCalculated =
        startTime - timeUsedInCurrentSession;

      // const timeUsedInCurrentSessionCalculatedCalculated =
      //   previousTimeUsed + timeUsedInCurrentSessionCalculated;

      // previous time used is the start time

      // time used in current session will be added onto the previous time

      // time used in current session is current time (240)

      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/UpdateQuizTimeUsed?QuizSummaryId=${parsedQuizSummaryId}&TimeUsed=${timeUsedInCurrentSessionCalculated}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to post time used: ${response.status} ${response.statusText}`
        );
      }
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error submitting time data: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      postTime();
    }, 30001);

    return () => clearInterval(interval);
  }, []);

  const getSelectedAnswers = async (curriculumId) => {
    const sessionLoginToken = localStorage.getItem("loginToken");

    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/GetSelectedAnswers?CurriculumId=${curriculumId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch selected test answers");
      }

      const data = await response.json();

      const fetchedAnswers = data.map((item) => getProperty(item, 'answers') || item.Answers || item.answers);

      setSelectedAnswer(fetchedAnswers);
      return { selectedAnswer: fetchedAnswers };
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error getting answer data: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const remainingQuestionsCalculation = () => {
    if (liveCurrentQuizQuestions) {
      const attemptedQuestions = liveCurrentQuizQuestions.filter(
        (question) => {
          const questionAttempted = getProperty(question, 'questionAttempted') || getProperty(question, 'QuestionAttempted') || question?.QuestionAttempted || question?.questionAttempted || '';
          return questionAttempted === "Y";
        }
      );

      return totalQuestions - attemptedQuestions.length;
    }

    return null;
  };

  const remainingQuestionsPercent = () => {
    if (liveCurrentQuizQuestions && testData) {
      const amountOfQuestionsAttempted = liveCurrentQuizQuestions.filter(
        (question) => {
          const questionAttempted = getProperty(question, 'questionAttempted') || getProperty(question, 'QuestionAttempted') || question?.QuestionAttempted || question?.questionAttempted || '';
          return questionAttempted === "Y";
        }
      ).length;

      const newPercent = (amountOfQuestionsAttempted / totalQuestions) * 100;
      setRemainingPercent(newPercent);
    }
  };

  useEffect(() => {
    remainingQuestionsPercent();
  }, [singleQuizQuestion]);

  const startQuiz = async (curriculumId) => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      const response = await fetch(`${prefix}/api-40/api40/Lesson/StartTest`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionLoginToken}`,
          "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
        },
        body: JSON.stringify({
          AnswerOptionId: 0,
          QuestionId: 0,
          AnswerPresentation: "",
          AnswerOptionType: 0,
          StudentAnswer: "",
          IsChecked: true,
          NewAnswer: "",
          CurrId: curriculumId,
          TimeUsed: 0,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch test answers");
      }
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error setting start of quiz: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const getSingleQuestion = async (curriculumId) => {
    const sessionLoginToken = localStorage.getItem("loginToken");

    if (quizSummaryId && curriculumId) {
      try {
        const response = await fetch(
          `${prefix}/api-40/api40/Lesson/GetLiveQuizQuestions?QuizSummaryId=${quizSummaryId}&CirriculumId=${curriculumId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch test answers");
        }
        const data = await response.json();
        const normalizedData = normalizeTestQuestions(data);

        setSingleQuizQuestion(normalizedData);

        if (normalizedData && normalizedData[0]) {
          const questionItem = normalizedData[0];
          const questionIdValue = getProperty(questionItem, 'questionId') || getProperty(questionItem, 'QuestionId') || questionItem?.QuestionId || questionItem?.questionId;
          const curriculumIdValue = getProperty(questionItem, 'curriculumId') || getProperty(questionItem, 'CurriculumId') || questionItem?.CurriculumId || questionItem?.curriculumId;
          const questionNumberValue = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber;
          const totalQuestionsValue = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions;

          setQuestionId(questionIdValue);

          if (questionIdValue) {
            localStorage.setItem("questionId", JSON.stringify(questionIdValue));
          }

          setCurriculumId(curriculumIdValue);

          if (curriculumIdValue) {
            localStorage.setItem("curriculumId", JSON.stringify(curriculumIdValue));
          }

          setQuestionNumber(questionNumberValue);
          setTotalQuestions(totalQuestionsValue);

          return {
            singleQuizQuestion: normalizedData,
            questionId: questionIdValue,
            curriculumId: curriculumIdValue,
            questionNumber: questionNumberValue,
            totalQuestion: totalQuestionsValue,
          };
        }
      } catch (error) {
        try {
          await fetch(`${prefix}/api-40/Log/Log`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
            },
            body: JSON.stringify({
              Message: `Error getting single question: ${error.message}`,
              Time: new Date().toISOString(),
            }),
          });
        } catch (logError) {
        }

      }
    }
  };

  const getTestAnswers = async (passedQuestionId) => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    const sessionQuestionId = localStorage.getItem("questionId");

    let newQuestionId;

    if (sessionQuestionId) {
      newQuestionId = sessionQuestionId;
    } else if (passedQuestionId) {
      newQuestionId = passedQuestionId;
    } else {
      newQuestionId = questionId;
    }

    if (testQuestions) {
      try {
        const response = await fetch(
          `${prefix}/api-40/api40/Lesson/GetLiveQuizAnswerOptions?QuestionId=${newQuestionId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch test answers");
        }
        const data = await response.json();
        setTestAnswers(data);
        return { setTestAnswers: data };
      } catch (error) {
        try {
          await fetch(`${prefix}/api-40/Log/Log`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
            },
            body: JSON.stringify({
              Message: `Error fetching test answers: ${error.message}`,
              Time: new Date().toISOString(),
            }),
          });
        } catch (logError) {
        }

      }
    }
  };

  const getTestQuestions = async () => {
    if (testData) {
      const currentQuizSummaryId = localStorage.getItem("quizSummaryId");

      if (!currentQuizSummaryId) {
        return;
      }

      let parsedQuizSummaryId;
      try {
        parsedQuizSummaryId = JSON.parse(currentQuizSummaryId);
      } catch (error) {
        // If parsing fails, try using it as a number directly
        parsedQuizSummaryId = currentQuizSummaryId;
      }

      localStorage.setItem("initalLoadComplete", true);

      const sessionLoginToken = localStorage.getItem("loginToken");

      if (!sessionLoginToken) {
        return;
      }

      if (quizSummaryId) {
        try {
          const response = await fetch(
            `${prefix}/api-40/api40/Lesson/GetLiveQuizQuestions?QuizSummaryId=${parsedQuizSummaryId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionLoginToken}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Failed to fetch test questions: ${response.status} ${response.statusText}`
            );
          }

          const data = await response.json();

          setTestQuestions(data);

          let newCurriculumId;

          const currentQuestion = data.find(
            (question) => {
              const questionItem = question[index] || question;
              const isCurrent = getProperty(questionItem, 'isCurrentQuestion') || getProperty(questionItem, 'IsCurrentQuestion') || questionItem?.IsCurrentQuestion || questionItem?.isCurrentQuestion;
              return isCurrent === "Y";
            }
          );

          if (currentQuestion) {
            newCurriculumId = getProperty(currentQuestion, 'curriculumId') || getProperty(currentQuestion, 'CurriculumId') || currentQuestion?.CurriculumId || currentQuestion?.curriculumId;

            setCurrentQuestion(currentQuestion);
          }

          if (!newCurriculumId && data[0]) {
            newCurriculumId = getProperty(data[0], 'curriculumId') || getProperty(data[0], 'CurriculumId') || data[0]?.CurriculumId || data[0]?.curriculumId;
          }

          getTitle();

          if (testData && testData[index]) {
            const testItem = testData[index];
            const startTime = getProperty(testItem, 'startTime') || getProperty(testItem, 'StartTime') || testItem?.StartTime || testItem?.startTime || '';
            if (!startTime && data[0]) {
              const curriculumIdToStart = getProperty(data[0], 'curriculumId') || getProperty(data[0], 'CurriculumId') || data[0]?.CurriculumId || data[0]?.curriculumId;
              if (curriculumIdToStart) {
                startQuiz(curriculumIdToStart);
              }
            }
          }

          if (!curriculumId) {
            setCurriculumId(newCurriculumId);
          }

          return {
            testQuestions: data,
            newCurriculumId: newCurriculumId,
          };
        } catch (error) {
          try {
            await fetch(`${prefix}/api-40/Log/Log`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionLoginToken}`,
              },
              body: JSON.stringify({
                Message: `Error fetching test questions: ${error.message}`,
                Time: new Date().toISOString(),
              }),
            });
          } catch (logError) {
          }

        }
      }
    }
  };

  const getLiveCurrentQuizQuestion = async () => {
    if (testData) {
      const currentQuizSummaryId = localStorage.getItem("quizSummaryId");

      if (!currentQuizSummaryId || currentQuizSummaryId === "undefined") {
        return;
      }

      let parsedQuizSummaryId;
      try {
        parsedQuizSummaryId = JSON.parse(currentQuizSummaryId);
      } catch (error) {
        // If parsing fails, try using it as a number directly
        parsedQuizSummaryId = currentQuizSummaryId;
      }

      localStorage.setItem("initalLoadComplete", true);

      const sessionLoginToken = localStorage.getItem("loginToken");

      if (!sessionLoginToken) {
        return;
      }

      if (quizSummaryId) {
        try {
          const response = await fetch(
            `${prefix}/api-40/api40/Lesson/GetLiveCurrentQuestions?QuizSummaryId=${parsedQuizSummaryId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionLoginToken}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Failed to fetch test questions: ${response.status} ${response.statusText}`
            );
          }

          const data = await response.json();

          setLiveCurrentQuizQuestions(data);

          let newCurriculumId;

          const currentQuestion = data.find(
            (question) => {
              const questionItem = question[index] || question;
              const isCurrent = getProperty(questionItem, 'isCurrentQuestion') || getProperty(questionItem, 'IsCurrentQuestion') || questionItem?.IsCurrentQuestion || questionItem?.isCurrentQuestion;
              return isCurrent === "Y";
            }
          );

          if (currentQuestion) {
            newCurriculumId = getProperty(currentQuestion, 'curriculumId') || getProperty(currentQuestion, 'CurriculumId') || currentQuestion?.CurriculumId || currentQuestion?.curriculumId;
            setCurrentQuestion(currentQuestion);
          }

          if (!newCurriculumId && data[0]) {
            newCurriculumId = getProperty(data[0], 'curriculumId') || getProperty(data[0], 'CurriculumId') || data[0]?.CurriculumId || data[0]?.curriculumId;
          }
        } catch (error) {
          try {
            await fetch(`${prefix}/api-40/Log/Log`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionLoginToken}`,
              },
              body: JSON.stringify({
                Message: `Error fetching test questions: ${error.message}`,
                Time: new Date().toISOString(),
              }),
            });
          } catch (logError) {
          }

        }
      }
    }
  };

  const submitAnswer = async (answer) => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    if (answer) {
      try {
        const response = await fetch(
          `${prefix}/api-40/api40/Lesson/PostStudentAnswerMultipleChoice`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
            body: JSON.stringify({
              AnswerOptionId: 0,
              QuestionId: 0,
              AnswerPresentation: "",
              AnswerOptionType: 0,
              StudentAnswer: "",
              IsChecked: true,
              NewAnswer: answer,
              CurrId: curriculumId,
              TimeUsed: 0,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
      } catch (error) {
        try {
          await fetch(`${prefix}/api-40/Log/Log`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
            },
            body: JSON.stringify({
              Message: `Error setting start of quiz: ${error.message}`,
              Time: new Date().toISOString(),
            }),
          });
        } catch (logError) {
        }

      }
    }
  };

  const removeAnswer = async (answer) => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/PostRemoveStudentAnswerMultipleChoice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
          body: JSON.stringify({
            AnswerOptionId: 0,
            QuestionId: 0,
            AnswerPresentation: "",
            AnswerOptionType: 0,
            StudentAnswer: "",
            IsChecked: true,
            NewAnswer: answer,
            CurrId: curriculumId,
            TimeUsed: 0,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error removing answer: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const passQuestion = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/PassQuestion`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
          body: JSON.stringify({
            AnswerOptionId: 0,
            QuestionId: 0,
            AnswerPresentation: "",
            AnswerOptionType: 0,
            StudentAnswer: "",
            IsChecked: true,
            NewAnswer: "",
            CurrId: curriculumId,
            TimeUsed: 0,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
          body: JSON.stringify({
            Message: `Error setting start of quiz: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const handleRadioButtonSelect = (answer) => {
    const answerString = String(answer);

    if (!selectedAnswer.includes(answerString)) {
      const newSelectedAnswers = [...selectedAnswer, answerString];
      setSelectedAnswer(newSelectedAnswers);

      submitAnswer(answerString);
    } else {
      const newSelectedAnswers = selectedAnswer.filter(
        (a) => a !== answerString
      );
      setSelectedAnswer(newSelectedAnswers);

      removeAnswer(answerString);
    }
  };

  useEffect(() => {
    const handleInitialLoad = async () => {
      if (testData) {
        await getTestQuestions();
        await getLiveCurrentQuizQuestion();
      }
    };
    handleInitialLoad();
  }, [testData, initialLoadCompleted, window.history.state]);

  const generateNumberCircles = (isHovering, question) => {
    if (!singleQuizQuestion || !singleQuizQuestion[0]) return "circle-grey";
    const questionItem = singleQuizQuestion[0];
    const questionCurriculumId = getProperty(questionItem, 'curriculumId') || getProperty(questionItem, 'CurriculumId') || questionItem?.CurriculumId || questionItem?.curriculumId;
    const questionCurriculumIdToCompare = getProperty(question, 'curriculumId') || getProperty(question, 'CurriculumId') || question?.CurriculumId || question?.curriculumId;
    
    if (questionCurriculumIdToCompare === questionCurriculumId) {
      return isGcse
        ? isHovering
          ? "circle-blue-hover-gcse"
          : "circle-blue-gcse"
        : isHovering
        ? "circle-yellow-hover"
        : "circle-yellow";
    }

    const questionAttempted = getProperty(question, 'questionAttempted') || getProperty(question, 'QuestionAttempted') || question?.QuestionAttempted || question?.questionAttempted || '';
    
    if (questionAttempted === "Y") {
      return isGcse
        ? isHovering
          ? "circle-green-hover-gcse"
          : "circle-green-gcse"
        : isHovering
        ? "circle-green-hover"
        : "circle-green";
    }

    if (questionAttempted === "P") {
      return isGcse
        ? isHovering
          ? "circle-yellow-hover-gcse"
          : "circle-yellow-gcse"
        : isHovering
        ? "circle-orange-hover"
        : "circle-orange";
    }

    return "circle-grey";
  };

  const getNextQuestion = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      if (!singleQuizQuestion || !singleQuizQuestion[0] || !testQuestions) return;
      const questionItem = singleQuizQuestion[0];
      const currentQuestionNumber = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber;
      const nextQuestionIndex = currentQuestionNumber;
      const nextQuestion = testQuestions[nextQuestionIndex];
      
      if (!nextQuestion) return;
      
      const questionId = getProperty(nextQuestion, 'questionId') || getProperty(nextQuestion, 'QuestionId') || nextQuestion?.QuestionId || nextQuestion?.questionId;
      const curriculumId = getProperty(nextQuestion, 'curriculumId') || getProperty(nextQuestion, 'CurriculumId') || nextQuestion?.CurriculumId || nextQuestion?.curriculumId;

      if (nextQuestion && curriculumId) {
        await getSingleQuestion(curriculumId);
        if (questionId) {
          await getTestAnswers(questionId);
        }
        await updateCurrentQuestion();
      }
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
          },
          body: JSON.stringify({
            Message: `Error fetching next question: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  useEffect(() => {
    const getTheData = async () => {
      if (initialLoadCompleted) {
        if (singleQuizQuestion && singleQuizQuestion[0]) {
          const questionItem = singleQuizQuestion[0];
          const questionIdValue = getProperty(questionItem, 'questionId') || getProperty(questionItem, 'QuestionId') || questionItem?.QuestionId || questionItem?.questionId;
          if (questionIdValue) {
            await getTestAnswers(questionIdValue);
          }
        }
      }
    };

    getTheData();
  }, [singleQuizQuestion]);

  const updateCurrentQuestion = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");
    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/UpdateCurrentQuestion`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
          },
          body: JSON.stringify({
            CurriculumId: curriculumId,
            CurrentQuestion: "Y",
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      setQuestionUpdated((prevState) => !prevState);
    } catch (error) {
      try {
        await fetch(`${prefix}/api-40/Log/Log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionLoginToken}`,
            "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
          body: JSON.stringify({
            Message: `Error updating current question: ${error.message}`,
            Time: new Date().toISOString(),
          }),
        });
      } catch (logError) {
      }

    }
  };

  const getQuestionFromNumberButtons = async (number) => {
    const index = number - 1;
    if (!liveCurrentQuizQuestions || !liveCurrentQuizQuestions[index] || !testQuestions || !testQuestions[index]) return;
    
    const questionItem = liveCurrentQuizQuestions[index];
    const questionAttempted = getProperty(questionItem, 'questionAttempted') || getProperty(questionItem, 'QuestionAttempted') || questionItem?.QuestionAttempted || questionItem?.questionAttempted || '';
    
    if (questionAttempted === "N") {
      return;
    }
    
    const testQuestionItem = testQuestions[index];
    const curriculumId = getProperty(testQuestionItem, 'curriculumId') || getProperty(testQuestionItem, 'CurriculumId') || testQuestionItem?.CurriculumId || testQuestionItem?.curriculumId;
    
    if (curriculumId) {
      await getSingleQuestion(curriculumId);
      await getTestAnswers(questionId);
      await updateCurrentQuestion();
      getSelectedAnswers(curriculumId);
    }
  };

  const getQuestionFromTimeBar = async (index) => {
    if (!liveCurrentQuizQuestions || !liveCurrentQuizQuestions[index] || !testQuestions || !testQuestions[index]) return;
    
    const questionItem = liveCurrentQuizQuestions[index];
    const questionAttempted = getProperty(questionItem, 'questionAttempted') || getProperty(questionItem, 'QuestionAttempted') || questionItem?.QuestionAttempted || questionItem?.questionAttempted || '';
    
    if (questionAttempted === "N") {
      return;
    }
    
    const testQuestionItem = testQuestions[index];
    const curriculumId = getProperty(testQuestionItem, 'curriculumId') || getProperty(testQuestionItem, 'CurriculumId') || testQuestionItem?.CurriculumId || testQuestionItem?.curriculumId;
    
    if (curriculumId) {
      getSingleQuestion(curriculumId);
      getTestAnswers(questionId);
      updateCurrentQuestion();
      getSelectedAnswers(curriculumId);
    }
  };

  const handleNextClick = async () => {
    if (
      !selectedAnswer ||
      selectedAnswer.length === 0 ||
      selectedAnswer.every((answer) => answer === "")
    ) {
      setError("Please select an answer");
    } else {
      setSelectedAnswer([]);
      setError("");

      if (!singleQuizQuestion || !singleQuizQuestion[0] || !testQuestions) return;
      
      const questionItem = singleQuizQuestion[0];
      const questionNumber = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 0;
      const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 0;
      
      if (questionNumber < totalQuestions) {
        try {
          await getNextQuestion();
          await getLiveCurrentQuizQuestion();
          
          const nextQuestionIndex = questionNumber;
          if (testQuestions[nextQuestionIndex]) {
            const nextQuestionItem = testQuestions[nextQuestionIndex];
            const curriculumId = getProperty(nextQuestionItem, 'curriculumId') || getProperty(nextQuestionItem, 'CurriculumId') || nextQuestionItem?.CurriculumId || nextQuestionItem?.curriculumId;
            if (curriculumId) {
              await getSelectedAnswers(curriculumId);
            }
          }
        } catch (error) {
        }
      }
    }
  };

  const handlePassClick = async () => {
    setSelectedAnswer([]);
    setButtonClick((prevState) => !prevState);
    passQuestion();

    if (!singleQuizQuestion || !singleQuizQuestion[0] || !testQuestions) return;
    
    const questionItem = singleQuizQuestion[0];
    const questionNumber = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 0;
    const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 0;

    if (questionNumber < totalQuestions) {
      try {
        await getNextQuestion();
        await getLiveCurrentQuizQuestion();

        const nextQuestionIndex = questionNumber;
        if (testQuestions[nextQuestionIndex]) {
          const nextQuestionItem = testQuestions[nextQuestionIndex];
          const nextQuestionCurriculumId = getProperty(nextQuestionItem, 'curriculumId') || getProperty(nextQuestionItem, 'CurriculumId') || nextQuestionItem?.CurriculumId || nextQuestionItem?.curriculumId;

          if (nextQuestionCurriculumId) {
            await getSelectedAnswers(nextQuestionCurriculumId);
          }
        }
      } catch (error) {
      }
    }
  };

  const handleShowFinishButton = () => {
    if (!singleQuizQuestion || !singleQuizQuestion[0]) {
      setShowFinishButton(false);
      return;
    }
    const questionItem = singleQuizQuestion[0];
    const questionNumber = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 0;
    const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 0;
    
    if (questionNumber === totalQuestions) {
      setShowFinishButton(true);
    } else {
      setShowFinishButton(false);
    }
  };

  const handleShowNextButton = () => {
    if (!singleQuizQuestion || !singleQuizQuestion[0]) {
      setShowNextButton(false);
      return;
    }
    const questionItem = singleQuizQuestion[0];
    const questionNumber = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 0;
    const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 0;
    
    if (questionNumber && totalQuestions !== questionNumber) {
      setShowNextButton(true);
    } else {
      setShowNextButton(false);
    }
  };

  useEffect(() => {
    handleShowFinishButton();
    handleShowNextButton();
  }, [singleQuizQuestion, testAnswers]);

  const getTitle = () => {
    if (testData && index !== undefined && testData[index]) {
      const testItem = testData[index];
      const title = getProperty(testItem, 'quizTitle') || getProperty(testItem, 'QuizTitle') || testItem?.QuizTitle || testItem?.quizTitle || '';

      setTitle(title);
    }
  };

  useEffect(() => {
    localStorage.setItem("curriculumId", JSON.stringify(curriculumId));
  }, [curriculumId]);

  useEffect(() => {
    if (index !== undefined && testData && testData[index]) {
      const testItem = testData[index];
      const totalQuestions = getProperty(testItem, 'totalQuestions') || getProperty(testItem, 'TotalQuestions') || testItem?.TotalQuestions || testItem?.totalQuestions || 0;
      localStorage.setItem("totalQuestions", JSON.stringify(totalQuestions));
    }
  }, [index, testData]);

  useEffect(() => {
    if (testData && index) {
      const storedTotalQuestion = localStorage.getItem("totalQuestions");
      if (storedTotalQuestion) {
        setTotalQuestions(storedTotalQuestion);
      }
      setSelectedQuiz(testData[index]);
    }
  }, []);

  useEffect(() => {
    const storedQuestionId = localStorage.getItem("questionId");
    if (storedQuestionId) {
      setQuestionId(Number(storedQuestionId));
    }
  }, []);

  useEffect(() => {
    const storedTestData = localStorage.getItem("testData");
    const storedQuizSummaryId = localStorage.getItem("quizSummaryId");
    const storedTimeRemaining = localStorage.getItem("timeRemaining");
    const storedIndex = localStorage.getItem("quizIndex");
    const storedCurriculumId = localStorage.getItem("curriculumId");
    const storedTestQuestions = localStorage.getItem("testQuestions");
    const storedIsGcse = localStorage.getItem("isGcse");

    if (storedIsGcse === "true") {
      setIsGcse(true);
    } else {
      setIsGcse(false);
    }

    if (storedTestData) {
      setTestData(JSON.parse(storedTestData));
    }

    if (storedTestQuestions) {
      setTestQuestions(JSON.parse(storedTestQuestions));
    }

    if (storedQuizSummaryId && storedQuizSummaryId !== "undefined") {
      const parsedQuizSummaryId = JSON.parse(storedQuizSummaryId);

      setQuizSummaryId(parsedQuizSummaryId);
    }

    if (storedTimeRemaining && timeRemainingRef.current === 0) {
      setTimeRemaining(Number(storedTimeRemaining));
    }

    if (storedIndex) {
      setIndex(Number(storedIndex));
    }
  }, []);

  useEffect(() => {
    if (timeRemaining && timeRemaining >= 0) {
      const countdownInterval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          const newTime = prevTime - 1;
          timeRemainingRef.current = newTime;
          if (newTime >= 0) {
            localStorage.setItem("timeRemaining", newTime);
          }
          if (newTime <= 0) {
            clearInterval(countdownInterval);
            submitTest();
            navigate("/quizScreen");
          }
          return newTime;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, [timeRemaining]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        let fetchedCurriculumId;
        let fetchedTestQuestions;
        let fetchedQuestionsToStart;
        let fetchedSingleQuizQuestion;
        let fetchedQuestionId;
        let fetchedQuestionNumber;
        let fetchedTotalQuestion;
        let fetchedSelectedAnswer;

        setCurrentQuestion(null);
        setTestQuestions([]);
        setInitialLoadCompleted(false);

        if (testData && !initialLoadCompleted) {
          const { newCurriculumId, testQuestions } = await getTestQuestions();

          fetchedCurriculumId = newCurriculumId;

          fetchedTestQuestions = testQuestions;
        }

        if (fetchedTestQuestions && !initialLoadCompleted) {
          const result = findCurrentQuestion(fetchedTestQuestions);
          if (result && result.fetchedQuestionToStart) {
            const { fetchedQuestionToStart } = result;

            fetchedQuestionsToStart = fetchedQuestionToStart;
          }
        }

        if (fetchedQuestionsToStart && !initialLoadCompleted) {
          const {
            singleQuizQuestion,
            questionId,
            curriculumId: returnedCurriculumId,
            questionNumber,
            totalQuestion,
          } = await getSingleQuestion(fetchedQuestionsToStart);

          fetchedSingleQuizQuestion = singleQuizQuestion;
          fetchedQuestionId = questionId;
          fetchedCurriculumId = returnedCurriculumId;
          fetchedQuestionNumber = questionNumber;
          fetchedTotalQuestion = totalQuestion;

          const questionIdToUse = fetchedQuestionId || questionId;
          const fallbackQuestionId = fetchedTestQuestions && fetchedTestQuestions[0] 
            ? (getProperty(fetchedTestQuestions[0], 'questionId') || getProperty(fetchedTestQuestions[0], 'QuestionId') || fetchedTestQuestions[0]?.QuestionId || fetchedTestQuestions[0]?.questionId)
            : null;
          await getTestAnswers(questionIdToUse || fallbackQuestionId);

          const curriculumIdToUse = fetchedQuestionsToStart;
          if (!curriculumIdToUse && fetchedTestQuestions && fetchedTestQuestions[0]) {
            const curriculumIdFromData = getProperty(fetchedTestQuestions[0], 'curriculumId') || getProperty(fetchedTestQuestions[0], 'CurriculumId') || fetchedTestQuestions[0]?.CurriculumId || fetchedTestQuestions[0]?.curriculumId;
            if (curriculumIdFromData) {
              fetchedSelectedAnswer = await getSelectedAnswers(curriculumIdFromData);
            }
          } else if (curriculumIdToUse) {
            fetchedSelectedAnswer = await getSelectedAnswers(curriculumIdToUse);
          }
        } else if (!initialLoadCompleted) {
          const {
            singleQuizQuestion,
            questionId,
            curriculumId: returnedCurriculumId,
            questionNumber,
            totalQuestion,
          } = await getSingleQuestion(fetchedCurriculumId || curriculumId);

          fetchedSingleQuizQuestion = singleQuizQuestion;
          fetchedQuestionId = questionId;
          fetchedCurriculumId = returnedCurriculumId;
          fetchedQuestionNumber = questionNumber;
          fetchedTotalQuestion = totalQuestion;

          const questionIdToUse = fetchedQuestionId || questionId;
          if (!questionIdToUse && fetchedTestQuestions && fetchedTestQuestions[0]) {
            const questionIdFromData = getProperty(fetchedTestQuestions[0], 'questionId') || getProperty(fetchedTestQuestions[0], 'QuestionId') || fetchedTestQuestions[0]?.QuestionId || fetchedTestQuestions[0]?.questionId;
            if (questionIdFromData) {
              await getTestAnswers(questionIdFromData);
            }
          } else if (questionIdToUse) {
            await getTestAnswers(questionIdToUse);
          }

          const curriculumIdToUse = fetchedCurriculumId || curriculumId;
          if (!curriculumIdToUse && fetchedTestQuestions && fetchedTestQuestions[0]) {
            const curriculumIdFromData = getProperty(fetchedTestQuestions[0], 'curriculumId') || getProperty(fetchedTestQuestions[0], 'CurriculumId') || fetchedTestQuestions[0]?.CurriculumId || fetchedTestQuestions[0]?.curriculumId;
            if (curriculumIdFromData) {
              fetchedSelectedAnswer = await getSelectedAnswers(curriculumIdFromData);
            }
          } else if (curriculumIdToUse) {
            fetchedSelectedAnswer = await getSelectedAnswers(curriculumIdToUse);
          }
        }

        setInitialLoadCompleted(true);
      } catch (error) {
      }
    };

    if (testData && quizSummaryId) {
      fetchInitialData();
    }

    const handleBeforeUnload = () => {
      localStorage.setItem("refreshTriggered", true);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [testData, quizSummaryId, location]);

  const displayTimeLine = () => {
    if (
      testData &&
      index !== undefined &&
      testData[index] &&
      singleQuizQuestion &&
      singleQuizQuestion[0]
    ) {
      const questionItem = singleQuizQuestion[0];
      const totalQuestions = getProperty(questionItem, 'totalQuestions') || getProperty(questionItem, 'TotalQuestions') || questionItem?.TotalQuestions || questionItem?.totalQuestions || 0;
      const questionNumberValue = getProperty(questionItem, 'questionNumber') || getProperty(questionItem, 'QuestionNumber') || questionItem?.QuestionNumber || questionItem?.questionNumber || 1;
      const questionNumber = questionNumberValue - 1;

      if (totalQuestions > 0 && questionNumber >= 0) {
        const sliderWidth = 100 / totalQuestions;
        const calculatedTranslatePercent = questionNumber * sliderWidth;

        return (
          <>
            <div
              className="w-full"
              style={{
                transform: `translateX(${calculatedTranslatePercent}%)`,
              }}
            >
              <img className="arrow-size" src={logoPointer} alt="pointer" />
            </div>
            <div key={index} className="flex">
              {[...Array(singleQuizQuestion && singleQuizQuestion[0] ? (getProperty(singleQuizQuestion[0], 'totalQuestions') || getProperty(singleQuizQuestion[0], 'TotalQuestions') || singleQuizQuestion[0]?.TotalQuestions || singleQuizQuestion[0]?.totalQuestions || 0) : 0)].map(
                (_, idx) => (
                  <TimeSlider
                    key={idx}
                    getQuestionFromTimeBar={getQuestionFromTimeBar}
                    index={idx}
                    percent={sliderWidth}
                    isGcse={isGcse}
                  />
                )
              )}
            </div>
          </>
        );
      }
    }
  };

  useEffect(() => {
    const setLoadingSpinner = () => {
      if (
        !testQuestions ||
        testQuestions.length === 0 ||
        !testAnswers ||
        testAnswers.length === 0 ||
        !testData ||
        testData.length === 0 ||
        !singleQuizQuestion ||
        singleQuizQuestion.length === 0 ||
        !curriculumId
      ) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    };

    setLoadingSpinner();
  }, [
    testQuestions,
    testAnswers,
    testData,
    singleQuizQuestion,
    questionId,
    curriculumId,
  ]);

  const prefixImage = (questionText) => {
    if (!questionText) return "";
    return questionText.replace(
      /<img\s+[^>]*src="(\/backoffice[^"]*)"/g,
      '<img src="https://ksol.co.uk$1"'
    );
  };

  if (loading) {
    return (
      <UniformLoader
        title="Loading..."
        message="Please wait while we load your test"
        subMessage=""
      />
    );
  }

  return (
    <>
      <Helmet>
        <title>Take Test | KSOL</title>
        <meta name="description" content="Take your 11+ practice test on KSOL. Complete timed questions and track your progress." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div
        className={`flex ${
          isGcse ? "bg-image-gcse" : "bg-image"
        } justify-center items-center overflow-y-auto overflow-hidden `}
      >
      <div className=" flex flex-col md:grid md:grid-cols-12 md:grid-rows-5 md:gap-4 grid-container">
        <div className="col-start-2 col-span-11 row-start-1 h-full">
          <div className="flex flex-col xl:flex-row items-center xl:items-end justify-between gap-4 text-center xl:text-start h-full">
            <h2 className={` ${isGcse ? "text-white" : ""}`}>{title}</h2>
            <img
              src={isGcse ? gcseLogo : logo}
              className="h-auto w-40 xl:w-56"
            />
          </div>
        </div>

        <div className="hidden md:flex col-span-1 row-start-3 flex justify-end items-start row-span-1">
          <NumberInCircle
            color={isGcse ? "blue" : "orange"}
            number={singleQuizQuestion && singleQuizQuestion[0] ? (getProperty(singleQuizQuestion[0], 'questionNumber') || getProperty(singleQuizQuestion[0], 'QuestionNumber') || singleQuizQuestion[0]?.QuestionNumber || singleQuizQuestion[0]?.questionNumber || 0) : 0}
          />
        </div>
        <div className="col-start-2 col-span-11 row-start-2 row-auto">
          <div className="flex flex-col justify-between text-center xl:text-start">
            <div className="p-4 mb-0  md:p-0 md:mb-4">
              {singleQuizQuestion && (
                <div className="mb-4">{displayTimeLine()}</div>
              )}
            </div>

            <div className="px-4">
              <div
                className={`flex h-full w-full mb-4 justify-center bg-white ${
                  isGcse ? "rounded-xl" : "rounded-3xl"
                } w-2/4 drop-shadow-lg xl:hidden`}
              >
                <p className="orange font-bold">{finalTime}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 md:p-0 col-start-2 col-span-8 row-start-3 row-auto">
          <div
            className={`bg-white w-full h-auto ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            } drop-shadow pb-10`}
          >
            <h3 className="p-4 font-bold ">Question</h3>
            {singleQuizQuestion.length > 0 && (() => {
              const questionItem = singleQuizQuestion[0];
              const curriculumId = getProperty(questionItem, 'curriculumId') || getProperty(questionItem, 'CurriculumId') || questionItem?.CurriculumId || questionItem?.curriculumId;
              const questionText = getProperty(questionItem, 'questionText') || getProperty(questionItem, 'QuestionText') || questionItem?.QuestionText || questionItem?.questionText || '';
              return (
                <p
                  key={curriculumId}
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: prefixImage(questionText),
                  }}
                />
              );
            })()}
            {singleQuizQuestion && singleQuizQuestion[0] && (() => {
              const questionItem = singleQuizQuestion[0];
              const rawGraphicLocation = getProperty(questionItem, 'graphicLocation') || getProperty(questionItem, 'GraphicLocation') || questionItem?.GraphicLocation || questionItem?.graphicLocation;
              const normalizedGraphicLocation = normalizeGraphicLocation(rawGraphicLocation);
              return normalizedGraphicLocation ? (
                <img
                  className="p-4"
                  src={`https://ksol.co.uk${normalizedGraphicLocation}`}
                  alt="Question graphic"
                />
              ) : null;
            })()}
            <div></div>
          </div>
          <div
            className={`bg-white w-full h-auto ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            } mt-2 drop-shadow pb-10`}
          >
            <h3 className="p-4 font-bold">Answer</h3>
            <div className="px-4 flex flex-col ">
              {testAnswers.map((answer) => {
                const answerOptionId = getProperty(answer, 'answerOptionId') || getProperty(answer, 'AnswerOptionId') || answer?.AnswerOptionId || answer?.answerOptionId;
                const answerPresentation = getProperty(answer, 'answerPresentation') || getProperty(answer, 'AnswerPresentation') || answer?.AnswerPresentation || answer?.answerPresentation || '';
                return (
                  <CustomRadioButton
                    key={answerOptionId}
                    answer={answerPresentation}
                    isSelected={Array.isArray(selectedAnswer) && selectedAnswer.includes(
                      answerOptionId?.toString()
                    )}
                    onSelect={() =>
                      handleRadioButtonSelect(answerOptionId)
                    }
                  />
                );
              })}
            </div>
            {error && (
              <p className="flex justify-start px-4 mt-4 text-red-500 text-sm">
                {error}
              </p>
            )}
          </div>
          <div className="flex justify-between md:justify-start md:gap-4 mt-4 mb-4">
            <div className="col-start-2 row-start-7 mb-4">
              <CustomButton
                onClick={handlePassClick}
                type={"pass"}
                text={"Pass"}
                isGcse={isGcse}
              />
            </div>
            {showNextButton && (
              <div className="col-start-3 row-start-7">
                <CustomButton
                  onClick={handleNextClick}
                  type={"next"}
                  text={"Next"}
                  isGcse={isGcse}
                />
              </div>
            )}
            {showFinishButton && (
              <div className="hidden md:block col-start-7 row-start-7 flex justify-end h-2/4">
                <CustomButton
                  onClick={handleFinishClick}
                  text={"Finish"}
                  type={"finish"}
                  isGcse={isGcse}
                />
              </div>
            )}
            {showFinishButton && (
              <div className="md:hidden md:block md:mt-0 md:mb-0 col-start-7 row-start-7 flex justify-end  mb-4  h-2/4">
                <CustomButton
                  onClick={handleFinishClick}
                  text={"Finish"}
                  type={"finish"}
                />
              </div>
            )}
          </div>
        </div>

        <div className="hidden p-4 md:p-0 md:block col-span-3 col-start-10 ">
          <div
            className={`p-6 bg-white flex flex-col justify-center w-full h-full ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            } drop-shadow`}
          >
            <h3 className="text-2xl font-bold">
              Total Questions:
              {testData && (
                <span
                  className={isGcse ? "blue" : "orange "}
                  key={quizSummaryId}
                >
                  {" "}
                  {singleQuizQuestion && singleQuizQuestion[0] ? (getProperty(singleQuizQuestion[0], 'totalQuestions') || getProperty(singleQuizQuestion[0], 'TotalQuestions') || singleQuizQuestion[0]?.TotalQuestions || singleQuizQuestion[0]?.totalQuestions || 0) : 0}
                </span>
              )}
            </h3>
            <h3 className="text-2xl font-bold">
              Unanswered Questions:
              <span className={isGcse ? "blue" : "orange "} key={quizSummaryId}>
                {" "}
                {remainingQuestionsCalculation()}
              </span>
            </h3>
          </div>
        </div>
        <div className="hidden md:block p-4 md:p-0 col-span-3 col-start-10 ">
          <div
            className={`bg-white flex items-center w-full h-full flex justify-center ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            } p-4 drop-shadow`}
          >
            <div className="flex flex-col">
              <h3 className="text-2xl font-bold">Time Remaining</h3>
              <h3
                className={
                  isGcse
                    ? "blue  text-center text-2xl font-bold"
                    : "orange text-center text-2xl font-bold "
                }
              >
                {finalTime}
              </h3>
            </div>
          </div>
        </div>
        <div className="p-4 md:p-0 col-span-3 col-start-10 row-span-1">
          <div
            className={`flex  bg-white w-full  overflow-y-auto  p-4 ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            } drop-shadow max-h-48`}
          >
            <div className="flex flex-col items-center w-full ">
              <h3 className="font-bold text-2xl mb-4">Go to question </h3>
              <div className="flex justify-center gap-4 flex-wrap">
                {liveCurrentQuizQuestions.map((question, index) => {
                  const questionCurriculumId = getProperty(question, 'curriculumId') || getProperty(question, 'CurriculumId') || question?.CurriculumId || question?.curriculumId;
                  return (
                    <NumberInCircle
                      key={index}
                      number={index + 1}
                      onClick={() => getQuestionFromNumberButtons(index + 1)}
                      isGcse={isGcse}
                      liveCurrentQuizQuestions={liveCurrentQuizQuestions}
                      currentCurriculumId={questionCurriculumId}
                      generateNumberCircles={(hover) =>
                        generateNumberCircles(hover, question)
                      }
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className=" col-start-10 col-span-3 "
          style={{ marginTop: "30px" }}
        >
          <div
            className={`flex flex-wrap items-start justify-center mt-4 w-full h-full mb-4 ${
              isGcse ? "rounded-xl" : "rounded-3xl"
            }`}
          >
            <div className="flex flex-wrap justify-between gap-6">
              <div className="flex flex-col gap-4 justify-start">
                <div className="flex flex-nowrap gap-6">
                  <div
                    className={isGcse ? "green-circle-gcse" : "green-circle"}
                  ></div>
                  <p className={isGcse ? "text-white" : ""}> Answered</p>
                </div>
                <div className="flex flex-nowrap gap-6">
                  <div
                    className={isGcse ? "blue-circle-gcse" : "yellow-circle"}
                  ></div>
                  <p className={isGcse ? "text-white" : ""}>Current</p>
                </div>
              </div>
              <div className="flex flex-col gap-4 justify-start">
                <div className="flex flex-nowrap gap-6">
                  <div
                    className={isGcse ? "yellow-circle-gcse" : "orange-circle"}
                  ></div>
                  <p className={isGcse ? "text-white" : ""}> Passed</p>
                </div>
                <div className="flex flex-nowrap gap-6">
                  <div className="grey-circle"></div>
                  <p className={isGcse ? "text-white" : ""}>Unattempted</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default TestTakingScreen;
